module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-modern-5-eab6b5387a0d5db3a7a5cb9073f44f56.webp";